<!-- Modal (Detalhes) -->

<ng-template #detalhes let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-detalhes"><b>Detalhes</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <!-- Razão Social -->

    <div class="form-group col-sm-12 p-0">
      <label class="text-secondary"><b>Razão Social:</b></label>

      <input class="form-control form-control-sm" type="text" name="cliente_razao_social" [value]="razaoSocial" disabled />
    </div>

    <hr class="mt-2 mb-2" />

    <!-- Comparativo de Vendas por Produto -->

    <div class="d-flex flex-column">
      <div class="quadro_comparativo p-2">
        <div class="text-center pb-2">
          <b>Comparativo de Vendas por Produto</b>
        </div>

        <div class="table-responsive">
          <table class="table table-sm table-hover">
            <thead>
              <tr>
                <th>Produto</th>
                <th class="text-right tabela_borda">1º Período: R$</th>
                <th class="text-right tabela_borda">2º Período: R$</th>
                <th class="text-center tabela_borda">Ganho/Perda: R$</th>
              </tr>
            </thead>

            <tbody>
              @for (analiseComparativaProduto of analiseComparativaProdutos; track analiseComparativaProduto) {
                <tr>
                  <td>{{ analiseComparativaProduto.name }}</td>
                  <td class="text-right tabela_borda">{{ analiseComparativaProduto.total_pedido_1periodo | currency: 'BRL' }}</td>
                  <td class="text-right tabela_borda">{{ analiseComparativaProduto.total_pedido_2periodo | currency: 'BRL' }}</td>
                  <td class="text-center tabela_borda">
                    @if (analiseComparativaProduto.ganho_perda > 0) {
                      <span class="badge badge-success">{{ analiseComparativaProduto.ganho_perda | currency: 'BRL' }}</span>
                    }
                    @if (analiseComparativaProduto.ganho_perda <= 0) {
                      <span class="badge badge-danger">{{ analiseComparativaProduto.ganho_perda | currency: 'BRL' }}</span>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <hr class="mt-2 mb-2" />

    <!-- Comparativo de Vendas por Marca -->

    <div class="d-flex flex-column">
      <div class="quadro_comparativo p-2">
        <div class="text-center pb-2">
          <b>Comparativo de Vendas por Marca</b>
        </div>

        <div class="table-responsive">
          <table class="table table-sm table-hover">
            <thead>
              <tr>
                <th>Marca</th>
                <th class="text-right tabela_borda">1º Período: R$</th>
                <th class="text-right tabela_borda">2º Período: R$</th>
                <th class="text-center tabela_borda">Ganho/Perda: R$</th>
              </tr>
            </thead>

            <tbody>
              @for (analiseComparativaProdutoAgrupado of analiseComparativaProdutosAgrupados; track analiseComparativaProdutoAgrupado) {
                <tr>
                  <td>{{ analiseComparativaProdutoAgrupado.grupo_estoque }}</td>
                  <td class="text-right tabela_borda">{{ analiseComparativaProdutoAgrupado.total_1periodo | currency: 'BRL' }}</td>
                  <td class="text-right tabela_borda">{{ analiseComparativaProdutoAgrupado.total_2Periodo | currency: 'BRL' }}</td>
                  <td class="text-center tabela_borda">
                    @if (analiseComparativaProdutoAgrupado.ganho_perda > 0) {
                      <span class="badge badge-success">{{ analiseComparativaProdutoAgrupado.ganho_perda | currency: 'BRL' }}</span>
                    }
                    @if (analiseComparativaProdutoAgrupado.ganho_perda <= 0) {
                      <span class="badge badge-danger">{{ analiseComparativaProdutoAgrupado.ganho_perda | currency: 'BRL' }}</span>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Ok')">Ok</button>
  </div>
</ng-template>

@if (!carregando) {
  <div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
    <!-- Título -->
    <div class="borda_inferior bg-light pt-3 pr-4 pb-3 pl-4">
      <div class="titulo_texto">Dashboard - Análise Comparativa</div>
    </div>
    <!-- Filtro -->
    <div class="pt-3 pr-4 pb-0 pl-4">
      <form [formGroup]="formFiltro" (ngSubmit)="filtrar()">
        <div class="form-row">
          <!-- 1º Período -->
          <div class="form-group col-sm-3">
            <label class="text-secondary"><b>Dt. Inicial: (1º Período)</b></label>
            <input class="form-control form-control-sm" type="text" name="filtrar_dt_inicial_1periodo" ngbDatepicker #dt_inicial_1periodo="ngbDatepicker" (click)="dt_inicial_1periodo.toggle()" formControlName="dt_inicial_1periodo" />
            @if (enviado && f.dt_inicial_1periodo.errors?.required) {
              <div class="erro pt-1">Dt. Inicial: (1º Período) em branco!</div>
            }
          </div>
          <div class="form-group col-sm-3">
            <label class="text-secondary"><b>Dt. Final: (1º Período)</b></label>
            <input class="form-control form-control-sm" type="text" name="filtrar_dt_final_1periodo" ngbDatepicker #dt_final_1periodo="ngbDatepicker" (click)="dt_final_1periodo.toggle()" formControlName="dt_final_1periodo" />
            @if (enviado && f.dt_final_1periodo.errors?.required) {
              <div class="erro pt-1">Dt. Final: (1º Período) em branco!</div>
            }
          </div>
          <!-- 2º Período -->
          <div class="form-group col-sm-3">
            <label class="text-secondary"><b>Dt. Inicial: (2º Período)</b></label>
            <input class="form-control form-control-sm" type="text" name="filtrar_dt_inicial_2periodo" ngbDatepicker #dt_inicial_2periodo="ngbDatepicker" (click)="dt_inicial_2periodo.toggle()" formControlName="dt_inicial_2periodo" />
            @if (enviado && f.dt_inicial_2periodo.errors?.required) {
              <div class="erro pt-1">Dt. Inicial: (2º Período) em branco!</div>
            }
          </div>
          <div class="form-group col-sm-3">
            <label class="text-secondary"><b>Dt. Final: (2º Período)</b></label>
            <input class="form-control form-control-sm" type="text" name="filtrar_dt_final_2periodo" ngbDatepicker #dt_final_2periodo="ngbDatepicker" (click)="dt_final_2periodo.toggle()" formControlName="dt_final_2periodo" />
            @if (enviado && f.dt_final_2periodo.errors?.required) {
              <div class="erro pt-1">Dt. Final: (2º Período) em branco!</div>
            }
          </div>
        </div>
        <div class="form-row">
          <!-- Cidade -->
          <div class="form-group col-sm-3">
            <label class="text-secondary"><b>Cidade:</b></label>
            <input class="form-control form-control-sm" type="text" name="filtrar_cidade" formControlName="cidade" />
          </div>
          <!-- Cliente -->
          <div class="form-group col-sm-4">
            <label class="text-secondary"><b>Cliente:</b></label>
            <input class="form-control form-control-sm" type="text" name="filtrar_cliente" formControlName="cliente" />
          </div>
          <!-- Vendedor(a) -->
          <div class="form-group col-sm-3">
            <label class="text-secondary"><b>Vendedor(a):</b></label>
            <input class="form-control form-control-sm" type="text" name="filtrar_vendedor" formControlName="vendedor" />
          </div>
          <div class="col-sm-2">
            <button class="btn btn-secondary btn_filtro" type="submit">Filtrar</button>
            @if (filtrado) {
              <button class="btn btn-secondary btn_filtro" type="button" (click)="removerFiltros()">Cancelar</button>
            }
          </div>
        </div>
      </form>
      <hr class="mt-2 mb-2" />
    </div>
    @if (filtrado) {
      <div class="pt-2 pr-4 pb-4 pl-4">
        <!-- Gráfico de Faturamento por Vendedor -->
        <div class="grafico_vendedor p-2">
          <div class="text-center pb-2">
            <b>Gráfico de Faturamento por Vendedor</b>
          </div>
          <div style="display: block;">
            <canvas baseChart
              [datasets]="barChartDataVendedor"
              [labels]="barChartLabelsVendedor"
              [options]="barChartOptionsVendedor"
              [plugins]="barChartPluginsVendedor"
              [legend]="barChartLegendVendedor"
              [chartType]="barChartTypeVendedor"
              [colors]="lineChartColorsVendedor"
              height="350">
            </canvas>
          </div>
        </div>
        <hr class="mt-2 mb-2" />
        <div class="d-flex flex-wrap justify-content-between">
          <!-- Comparativo entre Períodos por Cliente -->
          <div class="comparativo_cliente flex-grow-1">
            <div class="text-center p-2">
              <b>Comparativo entre Períodos por Cliente</b>
            </div>
            <div class="p-2">
              <div class="table-responsive">
                <cdk-virtual-scroll-viewport class="tabela_lg" [itemSize]="20">
                  <table class="table table-sm table-hover">
                    <thead>
                      <tr>
                        <th></th>
                        <th class="tabela_borda">Cliente</th>
                        <th class="text-right tabela_borda">1º Período: R$</th>
                        <th class="text-right tabela_borda">2º Período: R$</th>
                        <th class="text-center tabela_borda">Ganho/Perda: R$</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *cdkVirtualFor="let analiseComparativaCliente of analiseComparativaClientes; templateCacheSize: 0;">
                        <td class="text-center tabela_acao">
                          <i class="fa fa-info btn_tabela_acao" placement="right" ngbTooltip="Detalhes" (click)="modalDetalhes(detalhes, analiseComparativaCliente.client_id_app, analiseComparativaCliente.name)"></i>
                        </td>
                        <td class="tabela_borda">{{ analiseComparativaCliente.name }}</td>
                        <td class="text-right tabela_borda">{{ analiseComparativaCliente.total_pedido_1periodo | currency: 'BRL' }}</td>
                        <td class="text-right tabela_borda">{{ analiseComparativaCliente.total_pedido_2periodo | currency: 'BRL' }}</td>
                        <td class="text-center tabela_borda">
                          @if (analiseComparativaCliente.ganho_perda > 0) {
                            <span class="badge badge-success">{{ analiseComparativaCliente.ganho_perda | currency: 'BRL' }}</span>
                          }
                          @if (analiseComparativaCliente.ganho_perda <= 0) {
                            <span class="badge badge-danger">{{ analiseComparativaCliente.ganho_perda | currency: 'BRL' }}</span>
                          }
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td></td>
                        <td class="text-right tabela_borda"><b>Total: R$</b></td>
                        <td class="text-right tabela_borda"><b>{{ total1PeriodoClientes | currency: 'BRL' }}</b></td>
                        <td class="text-right tabela_borda"><b>{{ total2PeriodoClientes | currency: 'BRL' }}</b></td>
                        <td class="text-center tabela_borda">
                          @if (totalGanhoPerdaClientes > 0) {
                            <span class="badge badge-success">{{ totalGanhoPerdaClientes | currency: 'BRL' }}</span>
                          }
                          @if (totalGanhoPerdaClientes <= 0) {
                            <span class="badge badge-danger">{{ totalGanhoPerdaClientes | currency: 'BRL' }}</span>
                          }
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </cdk-virtual-scroll-viewport>
              </div>
            </div>
          </div>
          <!-- Comparativo entre Períodos por Cidade -->
          <div class="comparativo_cidade flex-grow-1">
            <div class="text-center p-2">
              <b>Comparativo entre Períodos por Cidade</b>
            </div>
            <div class="p-2">
              <div class="table-responsive">
                <cdk-virtual-scroll-viewport class="tabela_lg" [itemSize]="20">
                  <table class="table table-sm table-hover">
                    <thead>
                      <tr>
                        <th>Cidade</th>
                        <th class="text-right tabela_borda">1º Período: R$</th>
                        <th class="text-right tabela_borda">2º Período: R$</th>
                        <th class="text-center tabela_borda">Ganho/Perda: R$</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *cdkVirtualFor="let analiseComparativaClienteAgrupada of analiseComparativaClientesAgrupadas; templateCacheSize: 0;">
                        <td>{{ analiseComparativaClienteAgrupada.cidade }}</td>
                        <td class="text-right tabela_borda">{{ analiseComparativaClienteAgrupada.total_1periodo | currency: 'BRL' }}</td>
                        <td class="text-right tabela_borda">{{ analiseComparativaClienteAgrupada.total_2Periodo | currency: 'BRL' }}</td>
                        <td class="text-center tabela_borda">
                          @if (analiseComparativaClienteAgrupada.ganho_perda > 0) {
                            <span class="badge badge-success">{{ analiseComparativaClienteAgrupada.ganho_perda | currency: 'BRL' }}</span>
                          }
                          @if (analiseComparativaClienteAgrupada.ganho_perda <= 0) {
                            <span class="badge badge-danger">{{ analiseComparativaClienteAgrupada.ganho_perda | currency: 'BRL' }}</span>
                          }
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </cdk-virtual-scroll-viewport>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}
